import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../images/SafeCraft_logo.webp";
import { Button } from "@chakra-ui/react";

export default function NavBar() {
  return (
    <Navbar
      sticky="top"
      collapseOnSelect
      expand="lg"
      className="bg-body-tertiary"
    >
      <Container>
        <Navbar.Brand href="/">
          <img
            className="logo"
            src={logo}
            alt="SafeCrafts logo"
            loading="lazy"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#about-us">O nama</Nav.Link>
            <Nav.Link href="#faq">Često postavljana pitanja</Nav.Link>
          </Nav>
          <Nav>
            <Nav.Link href="#contact">
              <Button
                as="a"
                className="hero-btn"
                bg="#C9342D"
                color="white"
                variant="solid"
              >
                Kontaktirajte nas
              </Button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
